/*
 * Copyright (c) 2021-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';

import PropTypes from "prop-types";
import DisplayIcon from "../Icons/DisplayIcon.jsx";
import TextInput from "./TextInput.jsx";


class InputWithButton extends React.Component {


    render() {
        let buttons = this.props.buttons
        if (buttons === undefined) {
            buttons = [{
                onClick: this.props.onClick,
                iconName: this.props.iconName,
                isDisabled: false
            }]
        }

        return (<>
            {(this.props.name !== undefined) && (
                <label className="block text-sm font-medium text-gray-700 mb-1">{this.props.name}</label>)}

            <TextInput
                type={this.props.type}
                leadingImageURL={this.props.leadingImageURL}
                isReadOnly={this.props.isReadOnly}
                onChange={(event => {
                    if (this.props.onChange !== undefined) {
                        this.props.onChange(event)
                    }
                })}
                value={this.props.value}
                onFocus={() => {
                    if (this.props.onFocus !== undefined) {
                        this.props.onFocus()
                    }
                }}
                extend={<>
                    <div className={"p-1 z-10"}>
                        {(buttons ?? []).map((button, index) => {

                            return (<div
                                key={index}
                                tabIndex={0}
                                onClick={() => {
                                    if (button.onClick !== undefined && !button?.isDisabled) {
                                        button.onClick()
                                    }
                                }}
                                onKeyDown={(event) => {
                                    // handel the enter if the button is focus via a tab
                                    if (event.code === "Enter") {
                                        if (button.onClick !== undefined && !button?.isDisabled) {
                                            button.onClick()
                                        }
                                    }
                                }}
                                className={`p-2 h-8 w-8  flex justify-center items-center rounded cursor-pointer text-gray-400 bg-white/90  group-hover:text-gray-500 hover:bg-stone-100 focus-visible:bg-blue-100 focus-visible:outline-none focus-visible:text-blue-600 focus-visible:ring-1 ${(button?.isDisabled) && ("text-gray-200")}`}>
                                {button?.isLoading ? (
                                    <DisplayIcon iconName={"Spinner"} className=" animate-spin" size={"1.2em"}/>) : (
                                    <DisplayIcon iconName={button.iconName} size={"1.2em"}/>)}
                            </div>)

                            //
                            // return (<button onClick={() => {
                            //     if (button.onClick !== undefined && !button?.isDisabled) {
                            //         button.onClick()
                            //     }
                            // }}
                            //                 className={`-ml-px relative inline-flex items-center space-x-2 px-4 py-2  border border-gray-300 rounded-r-sm text-sm font-medium  text-gray-700 bg-gray-50 ${(button?.isDisabled) ? ("text-gray-400") : ("hover:bg-gray-100 focus:outline-none focus:ring-inset focus:ring-1 focus:border-indigo-500")} `}>
                            //     {button?.isLoading ? (
                            //         <CgSpinner className=" animate-spin" size={"1.3em"}/>) : (
                            //         <DisplayIcon iconName={button.iconName} size={"1.3em"}/>)}
                            // </button>)
                        })}
                    </div>
                </>}
                className={`  ${this.props.className}`}
                placeholder={this.props.placeholder}/>


        </>)
    };
}

export default InputWithButton;

InputWithButton.propTypes = {
    /**
     * The Placeholder of the input
     * @default '---'
     */
    placeholder: PropTypes.string,
    /**
     * The name of the icon of the button
     * @default 'IoPlayOutline'
     */
    iconName: PropTypes.string,
    /**
     * The value of the input
     */
    value: PropTypes.string,
    /**
     * The callback function of the input change
     */
    onChange: PropTypes.func,
    /**
     * The callback function of the input focus
     */
    onFocus: PropTypes.func,
    /**
     * The callback function of the button click
     */
    onClick: PropTypes.func,

    buttons: PropTypes.array,
}

InputWithButton.defaultProps = {
    placeholder: "---",
    iconName: "IoPlayOutline",

}